import React from 'react';

export default props => (

    <div>
      {props.children}
    </div>
);
